import { useState } from 'react'

import { JsonViewComponent } from './json'

interface TabComponent {
  tabs: {
    key: string
    heading: string
    content: string
    isJSON?: boolean
  }[]
  selectedTab: string
  tabHeadingRight?: string
}

export function TabComponent({
  tabs,
  selectedTab,
  tabHeadingRight,
}: TabComponent) {
  const [activeTab, setActiveTab] = useState<string>(selectedTab)

  return (
    <div className="bg-white-50 overflow-hidden rounded-[12px] border border-gray-200">
      <div className="ds-border-gray-200 ds-bg-white-100 ds-gap-6  ds-px-8 ds-text-12 flex border-b py-[8px]">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`ds-p-2 ds-px-8 cursor-pointer rounded-[12px] ${activeTab === tab.key ? 'ds-text-black-900 ds-border-half ds-border-white-500 ds-bg-white-100 bg-[#fff]' : 'ds-text-gray-600'}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.heading}
          </div>
        ))}

        {tabHeadingRight && (
          <div className="ds-text-12 ds-font-400 ds-text-black-900 ml-0">
            {tabHeadingRight}
          </div>
        )}
      </div>
      <div className="ds-px-12 ds-py-12 ds-text-12 overflow-auto">
        {tabs.map(
          (tab) =>
            activeTab === tab.key && (
              <pre
                key={tab.key}
                className="ds-font-mono ds-text-12 ds-font-400 ds-text-black-900 leading-[200%]"
              >
                {tab.isJSON ? (
                  <JsonViewComponent data={JSON.parse(tab.content)} />
                ) : (
                  tab.content
                )}
              </pre>
            ),
        )}
      </div>
    </div>
  )
}
